import { spacing } from "globalStyles";
import React, { ReactNode } from "react";
import styled from "styled-components";
import { breakpoints } from "themes/breakpoints";
import FlexBox, { FlexBoxSize } from "ui/FlexBox";
import Body from "ui/Text/Body";
import { TextColor } from "ui/Text/helper";

interface ValueOptions {
  color: TextColor;
}

export interface CellProps {
  label: string;
  value: ReactNode;
  size?: FlexBoxSize;
  valueOptions?: ValueOptions;
  className?: string;
}

const Cell: React.FC<CellProps> = ({
  label,
  value,
  size,
  className,
  valueOptions = { color: "secondary" },
}) => {
  return (
    <FlexBox className={`cell ${className}`} flexDirection="column" size={size}>
      <Body variant="body8" color="secondary">
        {label}
      </Body>
      {React.isValidElement(value) ? (
        value
      ) : (
        <ValueText className="card-cell-value" variant="body3" color={valueOptions.color}>
          {value}
        </ValueText>
      )}
    </FlexBox>
  );
};

export default Cell;

const ValueText = styled(Body)`
  margin-top: ${spacing.extraSmall}px;

  @media (max-width: ${breakpoints.md}) {
    margin-top: 0;
  }
`;
